<template>
  <div class="content">
    <Form ref="form" :model="formData" :label-width="150" :rules="rules">
      <Tabs v-model="activeTab">
        <TabPane label="线路转接" name="line">
          <FormItem label="坐席队列">
            <Input v-model="formData.queue_id" :disabled="!isEdit || isSaving" style="width: 420px"></Input>
          </FormItem>
          <FormItem label="转接超时时长">
            <InputNumber v-model="formData.transfer_timeout" :min="0" :disabled="!isEdit || isSaving" style="width: 200px"/><span style="margin-left: 5px">s</span>
          </FormItem>
          <FormItem label="隐藏对话内容">
            <i-switch v-model="formData.hide_conversation_content" :disabled="!isEdit || isSaving"/>
          </FormItem>
          <FormItem label="关闭坐席识别">
            <i-switch v-model="formData.disable_agent_asr" :disabled="!isEdit || isSaving"/>
          </FormItem>
          <FormItem label="关闭用户识别">
            <i-switch v-model="formData.disable_user_asr" :disabled="!isEdit || isSaving"/>
          </FormItem>
        </TabPane>
        <TabPane v-if="isGookiEnv" label="话术转接" name="script">
          <FormItem label="话术ID" prop="transfer_phone">
            <Input v-model.trim="formData.transfer_phone" :disabled="!isEdit || isSaving" placeholder="请输入话术ID" style="width: 420px" />
          </FormItem>
          <FormItem label="IP 地址" prop="transfer_ip">
            <Input v-model.trim="formData.transfer_ip" :disabled="!isEdit || isSaving" placeholder="请输入IP地址" style="width: 420px" />
          </FormItem>
        </TabPane>
      </Tabs>
      <FormItem>
        <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
        <Button type="primary" v-show="isEdit" :loading="isSaving" @click="save">保存</Button>
        <Button style="margin-left: 8px" v-show="isEdit" :disabled="isSaving" @click="cancel">取消</Button>
      </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isGookiEnv } from '@/utils/env';

const defaultTransfer = () => ({
  queue_id: '',
  transfer_timeout: 0,
  hide_conversation_content: false,
  disable_agent_asr: false,
  disable_user_asr: false,
  transfer_phone: '',
  transfer_ip: '',
});

export default {
  data() {
    const validateScriptField = (otherField, message) => (rule, value, callback) => {
      if (this.formData[otherField] && !String(value || '').trim()) {
        callback(new Error(message));
      } else {
        callback();
      }
    };
    return {
      isEdit: false,
      isSaving: false,
      activeTab: 'line',
      formData: defaultTransfer(),
      rules: {
        transfer_phone: [{ validator: validateScriptField('transfer_ip', '请输入话术ID'), trigger: 'blur' }],
        transfer_ip: [{ validator: validateScriptField('transfer_phone', '请输入IP地址'), trigger: 'blur' }],
      },
    }
  },
	computed: {
    isGookiEnv,
    ...mapState('setting', ['transfer']),
	},
  watch: {
    transfer: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    }
  },
  methods: {
    ...mapActions('setting', ['updateTransfer']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    resetForm() {
      if (this.$refs.form) this.$refs.form.resetFields();
      this.formData = { ...defaultTransfer(), ...this.transfer };
    },
    async save() {
      if (this.isSaving) return;
      const valid = await this.$refs.form.validate();
      if (!valid) {
        this.activeTab = 'script';
        return;
      }
      this.isSaving = true;
      try {
        await this.updateTransfer({ ...this.formData });
        this.isEdit = false;
      } catch (error) {
        // 请求错误由统一拦截器提示，保留编辑状态供用户重试。
      } finally {
        this.isSaving = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}
</style>
